import React, {PureComponent} from 'react';
import {UserContext} from "../../core/UserContext";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import {Regexer} from "../../core/auth/Regexer";
import Button from "@mui/material/Button";
import {UrlBuilder} from "../../core/url/UrlBuilder";
import {PageDataContext} from "../../core/PageDataContext";
import {
	CardContent,
	Card,
	Radio,
	RadioGroup,
	FormControlLabel,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Checkbox,
	IconButton, Collapse, InputAdornment
} from "@mui/material";
import SecurityIcon from '@mui/icons-material/Security';
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import {UnitPrettifier} from "../../core/prettifier/UnitPrettifier";
import TuneIcon from '@mui/icons-material/Tune';
import PaletteIcon from '@mui/icons-material/Palette';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import FeedbackIcon from '@mui/icons-material/Feedback';
import DialogContentText from "@mui/material/DialogContentText";
import CloseIcon from "@mui/icons-material/Close";
import Snackbar from "@mui/material/Snackbar";
import FavoriteIcon from '@mui/icons-material/Favorite';
import Badge2 from "../../res/img/badge_2.png";
import WhatshotIcon from '@mui/icons-material/Whatshot';
import Badge from "@mui/material/Badge";
import SubmitHasNoNotifications from "./partials/SubmitHasNoNotifications";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import DonationDialog from "./partials/DonationDialog";
import {withRouter} from "../../hooks/withRouter";
import Slide from "@mui/material/Slide";
import {Alert, AlertTitle} from "@mui/lab";
import GoogleIcon from "@mui/icons-material/Google";
import {Visibility, VisibilityOff} from "@mui/icons-material";
import AppleIcon from "@mui/icons-material/Apple";
import HelpCenterIcon from '@mui/icons-material/HelpCenter';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import LogoutIcon from '@mui/icons-material/Logout';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import SubscriptionDrawer from "./partials/SubscriptionDrawer";
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import StraightenIcon from '@mui/icons-material/Straighten';
import BugReportIcon from '@mui/icons-material/BugReport';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

class Settings extends PureComponent {

	constructor(props) {
		super(props);
		this.state = {
			isSubmitFeedbackDialogOpen: false,
			shouldIncludeFeedbackEmail: true,
			toastNotificationMessage: null,
			isSupporterDialogOpen: false,
			isSubscriptionDrawerOpen: false,
			isAnnouncementsCollapseOpen: false,
			isDeleteAccountDialogOpen: false,
			deleteConfirmationText: '',
			isEmailAlreadyTaken: false,
			showPassword: false,
		};

		this.configSectionRef = React.createRef();
		this.supporterSectionRef = React.createRef();
	}

	componentDidMount() {
		this.context.setPageData({
			title: "My Settings",
		});

		let goToDonation = (new URLSearchParams(this.props.location.search)).has('goToDonation');
		if (goToDonation) {
			setTimeout(() => this.scrollToSupporterSection(), 500);
		}
	}

	closeToastNotification = (event, reason) => {
		if (reason === 'clickaway') return;
		this.setState({ toastNotificationMessage: null });
	};

	setToastNotificationText = (text) => {
		this.setState({ toastNotificationMessage: text });
	}

	updateStateInputValues = (event) => {
		if (event.target.type !== "checkbox") {
			this.setState({
				[event.target.name]: event.target.value,
				isEmailAlreadyTaken: false,
			});
		} else {
			this.setState({
				[event.target.name]: event.target.checked,
				isEmailAlreadyTaken: false,
			});
		}
	}

	submitAccountDetailsWithEnter = (e, setUser, shouldSubmit) => {
		if (shouldSubmit && e.key === 'Enter') {
			this.submitAccountDetailsUpdate(e, setUser);
		}
	}

	submitConvertGuestToUserWithEnter = (e, setUser, shouldSubmit) => {
		if (shouldSubmit && e.key === 'Enter') {
			this.submitConvertGuestToUser(e, setUser);
		}
	}

	submitPasswordWithEnter = (e, setUser, shouldSubmit) => {
		if (shouldSubmit && e.key === 'Enter') {
			this.submitPasswordUpdate(e, setUser);
		}
	}

	logOut = async (event, setUser) => {
		event.preventDefault();

		await fetch('/api/users/logout', {
			method: 'post',
			headers: {
				'accept': 'application/json',
				'content-type': 'application/json'
			},
		});

		setUser(null);
		this.props.navigate('/');
	}

	updateUser = async (userModel, setUser) => {
		let response = await fetch(UrlBuilder.user.currentUserApi(), {
			method: 'PUT',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(userModel)
		});

		if (response.status === 200) {
			let userData = await response.json();
			setUser(userData['data']);
		}
	}

	submitPreferredUnitSystemId = async (event, user, setUser) => {
		event.preventDefault();
		event.stopPropagation();

		let value = event.target.value;

		let userView = {
			preferredUnitSystemId: value,
		};

		await this.updateUser(userView, setUser);

		this.setToastNotificationText('Unit system updated to ' + (value == UnitPrettifier.kg ? 'metric.' : 'imperial.'));
	}

	submitHasDarkModeEnabled = async (event, user, setUser) => {
		event.preventDefault();
		event.stopPropagation();

		let isEnabled = event.target.value === 'true';

		let userView = {
			hasDarkModeEnabled: isEnabled,
		};

		await this.updateUser(userView, setUser);

		this.setToastNotificationText(isEnabled ? 'Dark Mode enabled.' : 'Dark Mode disabled.');
	}

	submitConvertGuestToUser = async(e, setUser) => {
		e.preventDefault();

		let user = {
			name: this.state.name,
			email: this.state.email,
			password: this.state.password,
		};

		let response = await fetch(UrlBuilder.user.convertGuestToUserApi(), {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(user)
		});

		let jsonResponse = await response.json();

		if (response.status === 200) {
			setUser(jsonResponse['data']);
			this.setToastNotificationText('Account registered successfully.');
			this.setState({
				password: null,
				name: null,
				email: null,
			})
			return;
		}

		if (jsonResponse.message === "email_already_taken") {
			this.setState({
				isEmailAlreadyTaken: true,
			})
		}
	}

	submitAccountDetailsUpdate = async (event, setUser) => {
		event.preventDefault();

		let userView = {
			name: this.state.name,
		};

		await this.updateUser(userView, setUser);

		this.setToastNotificationText('Details updated.')
	}

	submitPasswordUpdate = async (event, setUser) => {
		event.preventDefault();

		let userView = {
			password: this.state.password,
		};

		await this.updateUser(userView, setUser);

		this.setToastNotificationText('Password updated.')
	}

	submitFeedback = async (user) => {
		if (this.state.feedbackText) {
			const categoryLabels = { bug: 'Bug Report', feature: 'Feature Request', general: 'General' };
			const category = this.state.feedbackCategory || 'general';
			let feedbackView = {
				text: `[${categoryLabels[category]}] ${this.state.feedbackText}`,
			};

			if (this.state.shouldIncludeFeedbackEmail) {
				feedbackView['email'] = this.state.feedbackEmail ? this.state.feedbackEmail : user.email;
			}

			await fetch(UrlBuilder.user.feedbackApi(), {
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(feedbackView)
			});

			this.setToastNotificationText('Thanks for your feedback!')
		}

		this.openSubmitFeedbackDialog(false);
	}

	openSubmitFeedbackDialog = (isOpen) => {
		this.setState({ isSubmitFeedbackDialogOpen: isOpen });
	}

	openDeleteAccountDialog = (isOpen) => {
		this.setState({
			isDeleteAccountDialogOpen: isOpen,
			deleteConfirmationText: '',
		});
	}

	deleteAccount = async (setUser) => {
		const response = await fetch('/api/users/current', {
			method: 'DELETE',
			headers: {
				'accept': 'application/json',
				'content-type': 'application/json'
			},
		});

		if (response.ok) {
			setUser(null);
			this.props.navigate('/');
		} else {
			this.openDeleteAccountDialog(false);
			this.setToastNotificationText('Failed to delete account. Please try again.');
		}
	}

	openSupporterDialog = (isOpen) => {
		this.setState({ isSupporterDialogOpen: isOpen });
	}

	openSubscriptionDrawer = (isOpen) => {
		this.setState({ isSubscriptionDrawerOpen: isOpen });
	}

	scrollToSupporterSection = () => {
		if (this.supporterSectionRef && this.supporterSectionRef.current) {
			this.supporterSectionRef.current.scrollIntoView({behavior: 'smooth'});
		}
	}

	scrollToConfigSection = () => {
		if (this.configSectionRef) {
			this.configSectionRef.current.scrollIntoView({behavior: 'smooth'});
		}
	}

	openAnnouncementsCollapse = () => {
		this.setState({ isAnnouncementsCollapseOpen: !this.state.isAnnouncementsCollapseOpen });
	}

	redirectToGoogleAuth = () => {
		window.location = '/api/users/google-signin';
	}

	redirectToAppleAuth = () => {
		window.location = '/api/users/apple-signin';
	}

	showPassword = () => {
		this.setState({ showPassword: !this.state.showPassword });
	}

	goToManualPage = () => {
		this.props.navigate(UrlBuilder.misc.manualPage());
	}

	renderSectionHeader = (icon, title) => (
		<Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
			<Box sx={{
				width: 36, height: 36, borderRadius: '50%',
				display: 'flex', alignItems: 'center', justifyContent: 'center',
				bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.04)',
			}}>
				{React.cloneElement(icon, { sx: { fontSize: 20, color: 'text.secondary' } })}
			</Box>
			<Typography variant="h6" sx={{ fontWeight: 600, fontSize: 18 }}>
				{title}
			</Typography>
		</Box>
	)

	renderSettingRow = (icon, label, description, onClick, extra = null) => (
		<Box
			onClick={onClick}
			sx={{
				display: 'flex', alignItems: 'center', gap: 1.5,
				p: 1.5, borderRadius: 2, cursor: onClick ? 'pointer' : 'default',
				transition: 'background 0.15s',
				'&:hover': onClick ? {
					bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.03)',
				} : {},
			}}
		>
			{React.cloneElement(icon, { sx: { fontSize: 22, color: 'text.secondary', flexShrink: 0 } })}
			<Box sx={{ flex: 1, minWidth: 0 }}>
				<Typography variant="body2" sx={{ fontWeight: 600 }}>{label}</Typography>
				{description && (
					<Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', lineHeight: 1.3 }}>
						{description}
					</Typography>
				)}
			</Box>
			{extra || (onClick && <ChevronRightIcon sx={{ fontSize: 20, color: 'text.disabled', flexShrink: 0 }} />)}
		</Box>
	)

	renderAnnouncementEntry = (date, items) => (
		<Box sx={{ mb: 2 }}>
			<Typography variant="caption" sx={{ fontWeight: 700, color: 'secondary.main', fontSize: 11, letterSpacing: 0.5 }}>
				{date}
			</Typography>
			<Box sx={{ mt: 0.5, display: 'flex', flexDirection: 'column', gap: 0.25 }}>
				{items.map((item, i) => (
					<Typography key={i} variant="body2" sx={{ fontSize: 13, lineHeight: 1.6, color: 'text.secondary' }}>
						{item}
					</Typography>
				))}
			</Box>
		</Box>
	)

	renderPersonalDetailsCardForUser = (user, setUser) => {
		let isSubmitDisabled = !this.state.name;

		let planLabel = "Free";
		let planCredits = "15 AI credits / month";
		if (user.activePlanIdentifier === "ai_access_plan") {
			planLabel = "Premium";
			planCredits = "150 AI credits / month";
		}

		return (
			<Card variant="outlined" sx={{ borderRadius: 2.5 }}>
				<CardContent sx={{ p: 2.5 }}>
					{this.renderSectionHeader(<AccountCircleIcon />, 'Account')}

					{/* Subscription Plan */}
					{this.renderSettingRow(
						<CardMembershipIcon />,
						'Subscription Plan',
						`${planLabel} · ${planCredits}`,
						() => this.openSubscriptionDrawer(true),
					)}

					<Box sx={{
						mt: 2, pt: 2,
						borderTop: '1px solid',
						borderColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.08)',
					}}>
						<Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5, fontSize: 11, display: 'block', mb: 1.5 }}>
							Personal Details
						</Typography>

						<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
							<TextField
								label="Email Address"
								name="email"
								defaultValue={user.email}
								disabled
								fullWidth
								size="small"
							/>
							<TextField
								required
								name="name"
								onChange={this.updateStateInputValues}
								label="Name"
								onKeyPress={(e) => this.submitAccountDetailsWithEnter(e, setUser, !isSubmitDisabled)}
								defaultValue={user.name}
								fullWidth
								size="small"
							/>
						</Box>
					</Box>

					<Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
						<Button
							variant="contained"
							color="secondary"
							onClick={(e) => this.submitAccountDetailsUpdate(e, setUser)}
							disabled={isSubmitDisabled}
							sx={{ textTransform: 'none', fontWeight: 600 }}
						>
							Save Details
						</Button>
					</Box>
				</CardContent>
			</Card>
		);
	};

	renderPersonalDetailsCardForGuest = (user, setUser) => {
		let isEmailInvalid = false;
		let emailFieldHelperText = null;
		if (this.state.email && !Regexer.testEmail(this.state.email)) {
			isEmailInvalid = true;
			emailFieldHelperText = 'Please enter a valid email'
		} else if (this.state.isEmailAlreadyTaken) {
			isEmailInvalid = true;
			emailFieldHelperText = 'Email is already taken, please try another one';
		}

		let isPasswordInvalid = false;
		let passwordFieldHelperText = null;
		if (this.state.password && !Regexer.testPassword(this.state.password)) {
			isPasswordInvalid = true;
			passwordFieldHelperText = 'Password must have a minimum length of 6 and contain a number.';
		}

		let isSubmitDisabled = !this.state.name || !this.state.email || isEmailInvalid || !this.state.password || isPasswordInvalid;

		return (
			<Card variant="outlined" sx={{ borderRadius: 2.5 }}>
				<CardContent sx={{ p: 2.5 }}>
					{this.renderSectionHeader(<AccountCircleIcon />, 'Account')}

					<Alert severity="info" sx={{ borderRadius: 2, mb: 2.5 }}>
						<AlertTitle sx={{ fontWeight: 600 }}>Register your account</AlertTitle>
						You're currently using a guest account. Register to sign back in and keep your data. No email verification required.
					</Alert>

					<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, alignItems: 'center', mb: 2.5 }}>
						<Button
							sx={{ width: 260, height: 44, textTransform: 'none', fontWeight: 600, borderRadius: 2 }}
							variant="contained"
							onClick={this.redirectToGoogleAuth}
							startIcon={<GoogleIcon />}
						>
							Continue with Google
						</Button>
						<Button
							sx={{ width: 260, height: 44, textTransform: 'none', fontWeight: 600, borderRadius: 2 }}
							variant="contained"
							onClick={this.redirectToAppleAuth}
							startIcon={<AppleIcon />}
						>
							Continue with Apple
						</Button>
					</Box>

					<Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, my: 2.5 }}>
						<Box sx={{ flex: 1, height: '1px', bgcolor: 'divider' }} />
						<Typography variant="caption" sx={{ color: 'text.disabled', fontWeight: 500 }}>
							OR REGISTER MANUALLY
						</Typography>
						<Box sx={{ flex: 1, height: '1px', bgcolor: 'divider' }} />
					</Box>

					<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
						<TextField
							required
							name="name"
							onChange={this.updateStateInputValues}
							label="Name"
							defaultValue={user.name}
							fullWidth
							size="small"
							onKeyPress={e => this.submitConvertGuestToUserWithEnter(e, setUser, !isSubmitDisabled)}
						/>
						<TextField
							required
							fullWidth
							label="Email Address"
							name="email"
							autoComplete="email"
							onChange={this.updateStateInputValues}
							error={isEmailInvalid}
							helperText={emailFieldHelperText}
							size="small"
							onKeyPress={e => this.submitConvertGuestToUserWithEnter(e, setUser, !isSubmitDisabled)}
						/>
						<TextField
							InputProps={{
								endAdornment:
									<InputAdornment position="end">
										<IconButton onClick={this.showPassword} edge="end" size="small">
											{this.state.showPassword ? <Visibility /> : <VisibilityOff />}
										</IconButton>
									</InputAdornment>
							}}
							required
							fullWidth
							name="password"
							label="Password"
							type={this.state.showPassword ? "text" : "password"}
							autoComplete="current-password"
							onChange={this.updateStateInputValues}
							error={isPasswordInvalid}
							helperText={passwordFieldHelperText}
							size="small"
							onKeyPress={e => this.submitConvertGuestToUserWithEnter(e, setUser, !isSubmitDisabled)}
						/>
					</Box>

					<Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
						<Button
							variant="contained"
							color="secondary"
							onClick={e => this.submitConvertGuestToUser(e, setUser)}
							disabled={isSubmitDisabled}
							sx={{ textTransform: 'none', fontWeight: 600 }}
						>
							Register Account
						</Button>
					</Box>
				</CardContent>
			</Card>
		);
	}

	renderDeleteAccountDialog = (setUser) => {
		return (
			<Dialog
				fullWidth
				maxWidth="sm"
				open={this.state.isDeleteAccountDialogOpen}
				onClose={() => this.openDeleteAccountDialog(false)}
				TransitionComponent={Transition}
				PaperProps={{ sx: { borderRadius: 3 } }}
			>
				<DialogTitle sx={{ fontWeight: 600 }}>Delete Account</DialogTitle>
				<DialogContent>
					<DialogContentText sx={{ mb: 2 }}>
						This action is permanent and cannot be undone. All of your data — workouts, exercises, routines, measurements, achievements, and settings — will be permanently deleted.
					</DialogContentText>
					<DialogContentText sx={{ mb: 1.5 }}>
						Type <strong>DELETE</strong> to confirm.
					</DialogContentText>
					<TextField
						autoFocus
						label="Type DELETE to confirm"
						variant="outlined"
						fullWidth
						size="small"
						value={this.state.deleteConfirmationText}
						onChange={(e) => this.setState({ deleteConfirmationText: e.target.value })}
					/>
				</DialogContent>
				<DialogActions sx={{ px: 3, py: 2, gap: 1 }}>
					<Button
						variant="outlined"
						onClick={() => this.openDeleteAccountDialog(false)}
						sx={{ textTransform: 'none' }}
					>
						Cancel
					</Button>
					<Button
						variant="contained"
						color="error"
						disabled={this.state.deleteConfirmationText !== 'DELETE'}
						onClick={() => this.deleteAccount(setUser)}
						sx={{ textTransform: 'none', fontWeight: 600 }}
					>
						Delete My Account
					</Button>
				</DialogActions>
			</Dialog>
		);
	}

	renderFeedbackCategoryChip = (id, icon, label) => {
		const isSelected = this.state.feedbackCategory === id;
		return (
			<Box
				onClick={() => this.setState({ feedbackCategory: id })}
				sx={{
					flex: 1, minWidth: 0,
					display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5,
					py: 1.25, borderRadius: 2, cursor: 'pointer',
					border: '1.5px solid',
					borderColor: isSelected ? 'secondary.main' : 'divider',
					bgcolor: isSelected
						? (theme) => theme.palette.mode === 'dark' ? 'rgba(245,0,87,0.08)' : 'rgba(245,0,87,0.04)'
						: 'transparent',
					transition: 'all 0.15s',
					'&:hover': { borderColor: isSelected ? 'secondary.main' : 'text.disabled' },
				}}
			>
				{React.cloneElement(icon, {
					sx: { fontSize: 22, color: isSelected ? 'secondary.main' : 'text.secondary' },
				})}
				<Typography variant="caption" sx={{
					fontWeight: isSelected ? 700 : 500, fontSize: 11,
					color: isSelected ? 'secondary.main' : 'text.secondary',
				}}>
					{label}
				</Typography>
			</Box>
		);
	}

	renderSubmitFeedbackDialog = (user) => {
		const categoryLabels = { bug: 'Bug Report', feature: 'Feature Request', general: 'General' };
		const placeholders = {
			bug: 'Describe the bug: what happened, what you expected, and steps to reproduce it...',
			feature: 'Describe the feature you\'d like to see and how it would help your workouts...',
			general: 'Share your thoughts, suggestions, or anything else...',
		};
		const category = this.state.feedbackCategory || 'general';

		return (
			<Dialog
				fullWidth
				maxWidth="sm"
				open={this.state.isSubmitFeedbackDialogOpen}
				onClose={() => this.openSubmitFeedbackDialog(false)}
				TransitionComponent={Transition}
				PaperProps={{ sx: { borderRadius: 3 } }}
			>
				<DialogTitle sx={{ pb: 0.5 }}>
					<Typography variant="h6" sx={{ fontWeight: 700, fontSize: 19 }}>
						Send Feedback
					</Typography>
					<Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.25, lineHeight: 1.4 }}>
						Your feedback directly shapes what gets built next.
					</Typography>
				</DialogTitle>

				<DialogContent sx={{ pt: 2 }}>
					{/* Category selector */}
					<Box sx={{ mb: 2 }}>
						<Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5, fontSize: 11, display: 'block', mb: 1 }}>
							Type
						</Typography>
						<Box sx={{ display: 'flex', gap: 1 }}>
							{this.renderFeedbackCategoryChip('bug', <BugReportIcon />, 'Bug')}
							{this.renderFeedbackCategoryChip('feature', <LightbulbIcon />, 'Feature')}
							{this.renderFeedbackCategoryChip('general', <ChatBubbleOutlineIcon />, 'General')}
						</Box>
					</Box>

					{/* Feedback text */}
					<Box sx={{ mb: 2 }}>
						<Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5, fontSize: 11, display: 'block', mb: 1 }}>
							Message
						</Typography>
						<TextField
							autoFocus
							placeholder={placeholders[category]}
							multiline
							rows={5}
							variant="outlined"
							fullWidth
							required
							name="feedbackText"
							onChange={this.updateStateInputValues}
							size="small"
						/>
					</Box>

					{/* Email opt-in */}
					<Box sx={{
						bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)',
						borderRadius: 2, px: 2, py: 1.5,
					}}>
						<FormControlLabel
							control={
								<Checkbox color="secondary" checked={this.state.shouldIncludeFeedbackEmail} name="shouldIncludeFeedbackEmail" onChange={this.updateStateInputValues} size="small" />
							}
							label={<Typography variant="body2" sx={{ fontWeight: 500 }}>Include my email for follow-up</Typography>}
						/>
						<Collapse in={this.state.shouldIncludeFeedbackEmail}>
							<TextField
								name="feedbackEmail"
								label="Email Address"
								type="email"
								fullWidth
								defaultValue={user.email}
								onChange={this.updateStateInputValues}
								value={this.state.feedbackEmail}
								size="small"
								sx={{ mt: 1 }}
							/>
						</Collapse>
					</Box>
				</DialogContent>

				<DialogActions sx={{ px: 3, py: 2, gap: 1 }}>
					<Button
						variant="outlined"
						onClick={() => this.openSubmitFeedbackDialog(false)}
						sx={{ textTransform: 'none' }}
					>
						Cancel
					</Button>
					<Button
						variant="contained"
						color="secondary"
						onClick={() => this.submitFeedback(user)}
						disabled={!this.state.feedbackText}
						sx={{ textTransform: 'none', fontWeight: 600, px: 3 }}
					>
						Send Feedback
					</Button>
				</DialogActions>
			</Dialog>
		);
	}

	renderAnnouncementsCard = (user) => (
		<Card variant="outlined" sx={{ borderRadius: 2.5 }}>
			<CardContent sx={{ p: 2.5, '&:last-child': { pb: 2.5 } }}>
				<Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
					<Box sx={{
						width: 36, height: 36, borderRadius: '50%',
						display: 'flex', alignItems: 'center', justifyContent: 'center',
						bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.04)',
					}}>
						{user.hasNotifications ? (
							<Badge badgeContent={1} color="secondary">
								<WhatshotIcon sx={{ fontSize: 20, color: 'text.secondary' }} />
							</Badge>
						) : (
							<WhatshotIcon sx={{ fontSize: 20, color: 'text.secondary' }} />
						)}
					</Box>
					<Box sx={{ flex: 1 }}>
						<Typography variant="h6" sx={{ fontWeight: 600, fontSize: 18 }}>
							What's New
						</Typography>
					</Box>
					<IconButton onClick={this.openAnnouncementsCollapse} size="small">
						{this.state.isAnnouncementsCollapseOpen ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
					</IconButton>
				</Box>

				{/* Latest announcement always visible */}
				{this.renderAnnouncementEntry('15 MAY 2026', [
					'• Modernize the entire UI of the app.',
					'• Themes, Animations & PR Styles: customize the look and feel of your app.',
					'• Workout Streaks & Achievement Badges, Workout Sharing, and PR Detection.',
					'• Compare to Previous Workouts during live sessions.',
					'• Smarter AI: look up your data, create exercises, routines, and goals.',
					'• Goals & Timer improvements: floating timer, presets, and notifications.',
				])}

				<Collapse in={this.state.isAnnouncementsCollapseOpen}>
					{this.renderAnnouncementEntry('5 MAY 2026', [
						'• AI Insights is now free for everyone: all accounts get 15 AI requests per month. Upgrade for 150 requests per month.',
					])}
					{this.renderAnnouncementEntry('25 OCTOBER 2025', [
						'• AI Insights & Trends: personalized workout analysis and progress insights.',
						'• App manual page with FAQ added to Settings.',
					])}
					{this.renderAnnouncementEntry('20 OCTOBER 2024', [
						'• Goals overview on home page.',
						'• Start Workout action bar in Routines page (including past workout logging).',
					])}
					{this.renderAnnouncementEntry('21 JANUARY 2024', [
						'• 1RM graphs included in graphs tab (Brzycki formula).',
					])}
					{this.renderAnnouncementEntry('9 JULY 2023', [
						'• Export exercise logs as CSV from the Filter menu.',
					])}
					{this.renderAnnouncementEntry('3 JULY 2023', [
						'• Global timer settings option.',
						'• RPE values shown in Max Reps per Weight graph.',
					])}
					{this.renderAnnouncementEntry('25 JUNE 2023', [
						'• Workout statistics section on homepage.',
						'• Overall performance and UI improvements.',
					])}
					{this.renderAnnouncementEntry('6 NOVEMBER 2022', [
						'• Custom colors for routines, exercises, and measurements.',
					])}
					{this.renderAnnouncementEntry('25 JULY 2022', [
						'• Quick button logs set before starting timer.',
						'• Quick timer start button in logger.',
					])}
					{this.renderAnnouncementEntry('2 APRIL 2022', [
						'• Muscle breakdown per exercise with workout muscle graph.',
					])}
					{this.renderAnnouncementEntry('19 FEBRUARY 2022', [
						'• Archive exercises in routines.',
						'• Show all logs for an exercise across routines.',
					])}
					{this.renderAnnouncementEntry('26 DECEMBER 2021', [
						'• Add past workouts from routine page.',
					])}
					{this.renderAnnouncementEntry('16 DECEMBER 2021', [
						'• Reorderable routine and measurement cards.',
					])}
					{this.renderAnnouncementEntry('11 DECEMBER 2021', [
						'• Superset auto-switching between exercises.',
					])}
					{this.renderAnnouncementEntry('14 NOVEMBER 2021', [
						'• Move exercises between routines while keeping logs.',
					])}
					{this.renderAnnouncementEntry('21 OCTOBER 2021', [
						'• Exercise supersets.',
					])}
					{this.renderAnnouncementEntry('27 MAY 2021', [
						'• Dark mode.',
						'• RPE/RIR logging.',
					])}
				</Collapse>

				{!this.state.isAnnouncementsCollapseOpen && (
					<Button
						onClick={this.openAnnouncementsCollapse}
						size="small"
						sx={{ textTransform: 'none', color: 'text.secondary', fontWeight: 500, mt: 0.5 }}
					>
						Show older updates
					</Button>
				)}
			</CardContent>
		</Card>
	)

	renderConfigurationsCard = (user, setUser) => (
		<Card variant="outlined" sx={{ borderRadius: 2.5 }}>
			<CardContent sx={{ p: 2.5 }} ref={this.configSectionRef}>
				{this.renderSectionHeader(<TuneIcon />, 'Preferences')}

				{/* Unit System */}
				<Box sx={{
					bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)',
					borderRadius: 2, p: 2, mb: 1.5,
				}}>
					<Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
						<StraightenIcon sx={{ fontSize: 16, color: 'text.disabled' }} />
						<Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5, fontSize: 11 }}>
							Unit System
						</Typography>
					</Box>
					<RadioGroup
						value={user.preferredUnitSystemId ?? UnitPrettifier.kg}
						onChange={(e) => this.submitPreferredUnitSystemId(e, user, setUser)}
						sx={{ pl: 0.5 }}
					>
						<FormControlLabel value={UnitPrettifier.kg} control={<Radio color="secondary" size="small" />} label={<Typography variant="body2">Metric (kg, km)</Typography>} />
						<FormControlLabel value={UnitPrettifier.lbs} control={<Radio color="secondary" size="small" />} label={<Typography variant="body2">Imperial (lbs, miles)</Typography>} />
					</RadioGroup>
				</Box>

				{/* Dark Mode */}
				<Box sx={{
					bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)',
					borderRadius: 2, p: 2, mb: 1.5,
				}}>
					<Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
						{user.hasDarkModeEnabled ? (
							<DarkModeIcon sx={{ fontSize: 16, color: 'text.disabled' }} />
						) : (
							<LightModeIcon sx={{ fontSize: 16, color: 'text.disabled' }} />
						)}
						<Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5, fontSize: 11 }}>
							Appearance
						</Typography>
					</Box>
					<RadioGroup
						value={user.hasDarkModeEnabled}
						onChange={(e) => this.submitHasDarkModeEnabled(e, user, setUser)}
						sx={{ pl: 0.5 }}
					>
						<FormControlLabel value={true} control={<Radio color="secondary" size="small" />} label={<Typography variant="body2">Dark Mode</Typography>} />
						<FormControlLabel value={false} control={<Radio color="secondary" size="small" />} label={<Typography variant="body2">Light Mode</Typography>} />
					</RadioGroup>
				</Box>

				{/* Customize Link */}
				<Box
					onClick={() => this.props.navigate(UrlBuilder.customize.customizePage())}
					sx={{
						cursor: 'pointer',
						borderRadius: 2,
						background: (theme) => `linear-gradient(135deg, ${theme.palette.secondary.main}18 0%, ${theme.palette.secondary.main}30 100%)`,
						border: '1px solid',
						borderColor: (theme) => `${theme.palette.secondary.main}40`,
						p: '14px 16px',
						display: 'flex',
						alignItems: 'center',
						gap: 1.5,
						transition: 'transform 0.15s, border-color 0.15s',
						'&:hover': {
							transform: 'translateY(-1px)',
							borderColor: 'secondary.main',
						},
						'&:active': {
							transform: 'scale(0.98)',
						},
					}}
				>
					<PaletteIcon sx={{ color: 'secondary.main', fontSize: 24 }} />
					<Box flex={1}>
						<Typography variant="body2" sx={{ fontWeight: 700, fontSize: '0.9rem', lineHeight: 1.2 }}>
							Customize
						</Typography>
						<Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '0.72rem' }}>
							Themes, animations & PR styles
						</Typography>
					</Box>
					<ChevronRightIcon sx={{ color: 'text.secondary', fontSize: 22 }} />
				</Box>
			</CardContent>
		</Card>
	)

	renderOtherCard = (user) => (
		<Card variant="outlined" sx={{ borderRadius: 2.5 }}>
			<CardContent sx={{ p: 2.5 }}>
				{this.renderSectionHeader(
					user.isSupporter ? <img src={Badge2} alt="Supporter" width={20} style={{ borderRadius: '50%' }} /> : <FavoriteIcon />,
					'Support & Help'
				)}

				<Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
					{this.renderSettingRow(
						<HelpCenterIcon />,
						'App Manual',
						'How the app works & FAQ',
						() => this.goToManualPage(),
					)}

					{this.renderSettingRow(
						<FeedbackIcon />,
						'Submit Feedback',
						'Bug reports, feature requests, or general feedback',
						() => this.openSubmitFeedbackDialog(true),
					)}

					{user.email && (
						<Box ref={this.supporterSectionRef}>
							{this.renderSettingRow(
								user.isSupporter
									? <img src={Badge2} alt="Supporter Badge" width={22} />
									: <FavoriteIcon />,
								user.isSupporter ? 'You are a supporter!' : 'Become a Supporter',
								user.isSupporter
									? 'View your badge and the Supporters List'
									: 'Purchase a supporter badge',
								() => this.openSupporterDialog(true),
							)}
						</Box>
					)}
				</Box>
			</CardContent>
		</Card>
	)

	renderSecurityCard = (user, setUser) => {
		let isPasswordInvalid = this.state.password && !Regexer.testPassword(this.state.password);
		let isConfirmDifferent = this.state.confirmPassword && this.state.password !== this.state.confirmPassword;
		let isPasswordSubmitDisabled = !this.state.password || isPasswordInvalid || !this.state.confirmPassword || isConfirmDifferent;

		return (
			<Card variant="outlined" sx={{ borderRadius: 2.5 }}>
				<CardContent sx={{ p: 2.5 }}>
					{this.renderSectionHeader(<SecurityIcon />, 'Security')}

					<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
						<TextField
							required
							fullWidth
							name="password"
							label="New Password"
							type="password"
							autoComplete="current-password"
							onChange={this.updateStateInputValues}
							placeholder="*********"
							InputLabelProps={{ shrink: true }}
							error={isPasswordInvalid}
							helperText={isPasswordInvalid ? "Password must have a minimum length of 6 and contain a number." : null}
							size="small"
						/>
						<TextField
							required
							fullWidth
							name="confirmPassword"
							label="Confirm Password"
							type="password"
							autoComplete="current-password"
							onChange={this.updateStateInputValues}
							placeholder="*********"
							InputLabelProps={{ shrink: true }}
							onKeyPress={e => this.submitPasswordWithEnter(e, setUser, !isPasswordSubmitDisabled)}
							error={isConfirmDifferent}
							helperText={isConfirmDifferent ? "Passwords must match." : null}
							size="small"
						/>
					</Box>

					<Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
						<Button
							variant="contained"
							color="secondary"
							disabled={isPasswordSubmitDisabled}
							onClick={e => this.submitPasswordUpdate(e, setUser)}
							sx={{ textTransform: 'none', fontWeight: 600 }}
						>
							Update Password
						</Button>
					</Box>
				</CardContent>
			</Card>
		);
	}

	renderSessionCard = (user, setUser) => (
		<Card variant="outlined" sx={{ borderRadius: 2.5 }}>
			<CardContent sx={{ p: 2.5 }}>
				{this.renderSectionHeader(<PowerSettingsNewIcon />, 'Session')}

				<Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
					{this.renderSettingRow(
						<LogoutIcon />,
						'Log Out',
						'Sign out of your account',
						(e) => this.logOut(e, setUser),
					)}

					<Box
						onClick={() => this.openDeleteAccountDialog(true)}
						sx={{
							display: 'flex', alignItems: 'center', gap: 1.5,
							p: 1.5, borderRadius: 2, cursor: 'pointer',
							transition: 'background 0.15s',
							'&:hover': {
								bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.03)',
							},
						}}
					>
						<DeleteForeverIcon sx={{ fontSize: 22, color: 'error.main', flexShrink: 0 }} />
						<Box sx={{ flex: 1, minWidth: 0 }}>
							<Typography variant="body2" sx={{ fontWeight: 600, color: 'error.main' }}>Delete Account</Typography>
							<Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', lineHeight: 1.3 }}>
								Permanently delete your account and all data
							</Typography>
						</Box>
					</Box>
				</Box>
			</CardContent>
		</Card>
	)

	render() {
		return (
            <UserContext.Consumer>
				{({user, setUser}) => {
					if (user) {
						return (
							<Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1.5, pb: 2 }}>
								{this.renderDeleteAccountDialog(setUser)}
								{this.renderSubmitFeedbackDialog(user)}

								<DonationDialog
									isOpen={this.state.isSupporterDialogOpen}
									closeSelfFunc={() => this.openSupporterDialog(false)}
								/>

								<SubscriptionDrawer
									isOpen={this.state.isSubscriptionDrawerOpen}
									closeSelfFunc={() => this.openSubscriptionDrawer(false)}
								/>

								<Snackbar
									anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
									open={this.state.toastNotificationMessage !== null}
									autoHideDuration={1500}
									onClose={this.closeToastNotification}
									message={this.state.toastNotificationMessage}
									action={
										<IconButton size="small" color="inherit" onClick={this.closeToastNotification}>
											<CloseIcon fontSize="small" />
										</IconButton>
									}
									style={{ paddingBottom: 55 }}
								/>

								{this.renderAnnouncementsCard(user)}

								{user.email
									? this.renderPersonalDetailsCardForUser(user, setUser)
									: this.renderPersonalDetailsCardForGuest(user, setUser)
								}

								{this.renderConfigurationsCard(user, setUser)}

								{this.renderOtherCard(user)}

								{user.email && this.renderSecurityCard(user, setUser)}

								{this.renderSessionCard(user, setUser)}

								<SubmitHasNoNotifications />
							</Box>
						);
					}
				}}
			</UserContext.Consumer>
        );
	}
}

Settings.contextType = PageDataContext;

export default withRouter(Settings);
